module.exports = __webpack_public_path__ + "static/flags/KG-9dedcc455c3115e108008c5bd9af9988.gif";